import PptIcon from '@/components/icons/powerpoint';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Button, Carousel, Row, Space, Tag, Tooltip } from 'antd';
import axios from 'axios';
import { getSession } from 'next-auth/react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import classes from './template-card.module.css';

function TemplatesCard(props) {
   const template = props.template;
   const disableShallow = props.disableShallow;
   const [hover, setHover] = useState(false);
   const carouselRef = useRef(null);
   const router = useRouter();
   const [isLiked, setIsLiked] = useState(template.is_liked);
   const currentCarousel = () => {
      return carouselRef.current;
   };

   async function handleLikeItem(e) {
      e.preventDefault();
      const id = template.id;
      const session = await getSession();
      const email = session?.user?.email;
      if (!email || !id) return;
      await axios.post('/api/user/favourites', { item_id: id });
      setIsLiked(!isLiked);
   }

   const ShallowLink = {
      href: { pathname: router.pathname, query: { ...router.query, template: template.slug } },
      as: `/template/${template.slug}`,
      shallow: true,
   };

   return (
      <>
         <Link {...(disableShallow ? { href: `/template/${template.slug}` } : ShallowLink)}>
            <div className={classes.cardBody}>
               {template.price > 0 && (
                  <div className={classes.premium}>
                     <i className="fi fi-sr-diamond" style={{ fontSize: 16, display: 'flex' }} />
                  </div>
               )}
               <div
                  className={classes.preview}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
               >
                  {Array.isArray(template.slides_gallery) ? (
                     <div className={classes.carousel}>
                        <div className={classes.arrowleft}>
                           <IconButton
                              className={classes.arrowLeft}
                              onClick={(e) => {
                                 e.preventDefault();
                                 currentCarousel().prev();
                              }}
                           >
                              <KeyboardArrowLeft />
                           </IconButton>
                        </div>
                        <div className={classes.arrowright}>
                           <IconButton
                              className={classes.arrowRight}
                              onClick={(e) => {
                                 e.preventDefault();
                                 currentCarousel().next();
                              }}
                           >
                              <KeyboardArrowRight />
                           </IconButton>
                        </div>
                        <Carousel
                           ref={carouselRef}
                           autoplay={hover}
                           autoplaySpeed={3000}
                           dots={false}
                           infinite={true}
                           speed={500}
                           pauseOnHover={false}
                           draggable={true}
                           lazyLoad={true}
                           className={classes.carousel}
                        >
                           {template.slides_gallery.map((slide, i) => (
                              <div key={i}>
                                 {slide?.sizes?.large && (
                                    <Image
                                       className={classes.carouselImage}
                                       src={slide?.sizes?.large}
                                       alt={template.title}
                                       width={455}
                                       height={255}
                                    />
                                 )}
                              </div>
                           ))}
                        </Carousel>
                     </div>
                  ) : (
                     <>
                        {template?.image?.large && (
                           <Image src={template?.image?.large} alt={template.title} width={455} height={255} />
                        )}
                     </>
                  )}
               </div>
               <div className={classes.details}>
                  <Space size="middle" direction="vertical" key="details" style={{ width: '100%' }}>
                     <h3>{template.title}</h3>
                     <Row justify="space-between">
                        {template.software === 'powerpoint' && (
                           <Tag color="orange" icon={<PptIcon style={{ fontSize: '14px' }} />}>
                              {template.software}
                           </Tag>
                        )}

                        {template.software === 'google-slides' && <Tag color="gold">{template.software}</Tag>}
                        <Space size="small" direction="vertical" key="actions">
                           <Tooltip
                              title={isLiked ? 'Remove from favourites' : 'Add to favourites'}
                              size="small"
                              mouseEnterDelay={0.5}
                           >
                              <Button
                                 icon={
                                    isLiked ? (
                                       <HeartFilled style={{ color: 'hotpink', fontSize: '12px' }} />
                                    ) : (
                                       <HeartOutlined style={{ fontSize: '12px' }} />
                                    )
                                 }
                                 size="small"
                                 shape="circle"
                                 onClick={handleLikeItem}
                              />
                           </Tooltip>
                        </Space>
                     </Row>
                  </Space>
               </div>
            </div>
         </Link>
      </>
   );
}
export default TemplatesCard;
